<script setup>
import img1 from "@img/wedo/marketing.webp"
import img2 from "@img/wedo/web.webp"

const items = [
    {
        title: 'Разработка и автоматизация',
        description: 'Проектируем и разрабатываем веб-сервисы, CRM и внутренние системы. Автоматизируем бизнес-процессы, интегрируем сервисы и создаём решения, которые реально ускоряют работу и увеличивают прибыль.',
        image: img1,
        alt: 'Разработка и автоматизация',
    },
    {
        title: 'Маркетинг и продвижение',
        description: 'Приводим целевой трафик и заявки: SEO, контекстная реклама, аналитика и воронки. Настраиваем систему привлечения клиентов, где каждый канал работает на рост продаж.',
        image: img2,
        alt: 'Маркетинг и продвижение',
    },
]
</script>

<template>
    <section class="relative overflow-hidden pt-14 pb-14 md:pb-24">
        <div class="pointer-events-none absolute inset-0 md:hidden">
            <div class="absolute left-[-60px] top-10 h-36 w-36 rounded-full bg-baseColor/10 blur-3xl"></div>
            <div class="absolute bottom-16 right-[-50px] h-32 w-32 rounded-full bg-black/5 blur-3xl"></div>
        </div>

        <div class="container relative z-10">
            <h2
                class="max-md:hidden text-center text-2xl font-extrabold leading-none text-black md:text-4xl md:-mb-8"
            >
                Комплексные решения
            </h2>

            <div class="md:hidden">
                <p
                    class="mb-3 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#7d8794]"
                >
                    Комплексные digital-решения для роста бизнеса
                </p>

                <div class="mb-8">
                    <h2
                        class="max-w-[280px] text-3xl font-extrabold uppercase leading-[0.95] tracking-[-0.04em] text-[#111111]"
                    >
                        Комплексные решения
                    </h2>

                    <div
                        class="mt-4 h-px w-full bg-gradient-to-r from-[#111111]/20 via-[#111111]/10 to-transparent"></div>
                </div>
            </div>

            <div class="relative mt-6 md:mt-14">
                <div class="pointer-events-none absolute inset-y-0 left-1/2 hidden -translate-x-1/2 md:block">
                    <div class="relative h-full w-px bg-black/15">
                        <div
                            class="absolute left-1/2 top-1/2 flex h-14 w-14 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-baseColor text-xl font-extrabold text-black shadow-lg"
                        >
                            И
                        </div>
                        <div class="absolute bottom-0 left-1/2 h-3 w-3 -translate-x-1/2 rounded-full bg-black/20"></div>
                    </div>
                </div>

                <div class="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-16 xl:gap-24">
                    <template v-for="(item, index) in items" :key="item.title">
                        <article
                            class="relative flex flex-col overflow-hidden md:items-center md:text-center max-md:rounded-[28px] max-md:border max-md:border-neutral-200/80 max-md:bg-white max-md:p-5 max-md:shadow-[0_12px_32px_rgba(0,0,0,0.06)]"
                        >
                            <div class="pointer-events-none absolute inset-0 md:hidden">
                                <div
                                    class="absolute inset-x-0 top-0 h-20 bg-gradient-to-b from-baseColor/5 to-transparent"></div>
                                <div
                                    class="absolute right-0 top-0 h-24 w-24 rounded-full bg-baseColor/10 blur-2xl"></div>
                            </div>

                            <div class="relative z-10 w-full md:flex md:flex-col md:items-center">
                                <div class="mb-4 flex items-center justify-between md:hidden">
                                    <span
                                        class="inline-flex items-center rounded-full border border-black/10 bg-black/[0.03] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-[#111111]">
                                        {{ index === 0 ? 'Цифровые решения' : 'Маркетинговые решения' }}
                                    </span>

                                    <span class="h-2.5 w-2.5 rounded-full bg-baseColor/80"></span>
                                </div>

                                <div class="w-full max-w-[520px]">
                                    <img
                                        :src="item.image"
                                        :alt="item.alt"
                                        class="mx-auto w-full max-w-[300px] object-contain md:h-[400px] md:max-w-none"
                                    >
                                </div>

                                <h3 class="mt-6 text-xl font-extrabold leading-none text-black md:mt-8 md:text-4xl">
                                    {{ item.title }}
                                </h3>

                                <p class="mt-4 max-w-[430px] text-sm text-black font-medium">
                                    {{ item.description }}
                                </p>
                            </div>
                        </article>
                    </template>
                </div>
            </div>
        </div>
    </section>
</template>
